(function () {
  var wishlistBadge = document.querySelector('[data-wishlist-nav-count]');
  var cartBadge = document.querySelector('[data-cart-nav-count]');

  function setBadge(badge, count) {
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function syncWishlistBadge() {
    if (!wishlistBadge || !window.Wishlist) return;
    setBadge(wishlistBadge, window.Wishlist.getAll().length);
  }

  syncWishlistBadge();
  document.addEventListener('wishlist:updated', syncWishlistBadge);
  window.addEventListener('storage', function (event) {
    if (event.key === 'kevilagu:wishlist') syncWishlistBadge();
  });

  if (cartBadge && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var itemCount = event && event.cartData && event.cartData.item_count;
      if (typeof itemCount === 'number') setBadge(cartBadge, itemCount);
    });
  }
})();
